import axiosInstance from '@/setup/axios/axiosInstance'
import { Address, AddressFormData, Province, Ward } from '../models/AddressModel'

// Get all provinces
export function getProvinces() {
  return axiosInstance.get<Province[]>('/addresses/provinces/', {
    params: {
      no_pagination: true,
    },
  })
}

// Get wards by province ID
export function getWardsByProvince(provinceId: string) {
  return axiosInstance.get<Ward[]>(`/addresses/provinces/${provinceId}/wards/`)
}

// Get all addresses
export function getAddresses() {
  return axiosInstance.get<Address[]>('/addresses/')
}

// Get single address by ID
export function getAddress(id: string) {
  return axiosInstance.get<Address>(`/addresses/${id}/`)
}

// Create new address
export function createAddress(addressData: AddressFormData) {
  return axiosInstance.post<Address>('/addresses/', addressData)
}

// Update address
export function updateAddress(id: string, addressData: AddressFormData) {
  return axiosInstance.put<Address>(`/addresses/${id}/`, addressData)
}

// Delete address
export function deleteAddress(id: string) {
  return axiosInstance.delete(`/addresses/${id}/`)
} 